import { useEffect, useState } from 'react';

import type { UseGeneratingTextAreaResult } from 'ui/generating-text-area/generating-text-area.types';

export const GENERATING_PLACEHOLDER = 'Generating';

export const IDLE_PLACEHOLDER =
  'Generate the text by clicking the button below...';

const MAX_DOTS = 3;

const DOT_INTERVAL_MS = 500;

export const useGeneratingTextArea = (
  loading: boolean
): UseGeneratingTextAreaResult => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    if (!loading) {
      return undefined;
    }

    setDotCount(0);
    const interval = setInterval(() => {
      setDotCount((count) => (count < MAX_DOTS ? count + 1 : 0));
    }, DOT_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [loading]);

  return {
    placeholder: loading
      ? `${GENERATING_PLACEHOLDER}${'.'.repeat(dotCount)}`
      : IDLE_PLACEHOLDER,
  };
};
